import axios from "@/axios";
import rsa from "@/component/utils/RSAPublicKey.js";
import { deleteAllIndexedDBs } from "@/component/utils/TempSave.js";
import editor from "@/editor/Editor.js";
import dc from "@/component/utils/DataChk";

let tt = null;

const fields = [
    "vulEnvironment",
    "vulDetection",
    "vulCause",
    "vulVerify",
    "vulScript",
    "vulAction",
];

export default {
    // 탭 이동 처리 함수(국내)
    triggerClickToTabDomestic(index, data) {
        let page = index - 1;

        // 개인정보작성 페이지 유효성 체크
        if (page == 0) {
            if (!dc.nullChk(data.userName)) {
                alert("성명을 입력해주세요.");
                return "userName";
            } else if (!dc.nullChk(data.userEngName)) {
                alert("영문명을 입력해주세요.");
                return "userEngName";
            } else if (!dc.nullChk(data.email) || !dc.emailValidChk(data.email)) {
                alert("이메일을 정확하게 입력해주세요.\n입력예시) korea@kisa.co.kr");
                return "email";
            } else if (!dc.nullChk(data.phone)) {
                alert("연락처를 입력해주세요.");
                return "phone";
            }
        } else if (page == 1) {
            // 확인사항 페이지 유효성 체크

            // 필수
            if (!data.hasNetworkLawConfirmed) {
                alert(
                    "정보통신망 이용촉진 및 정보보호 등에 관한 법률 위반행위 숙지 여부를 확인해주세요."
                );
                return false;
            } else if (!data.privateThirdYn) {
                alert("개인정보 제3자 제공에 동의해주세요.");
                return false;
            } else if (!data.secureYn) {
                alert("취약점 정보 활용 및 비밀유지에 동의해주세요.");
                return false;
            } else if (!data.excludingRewardsYn) {
                alert("신고포상제 평가 제외사항에 동의해주세요.");
                return false;
            } else if (!data.hasBugBountyGuideRead) {
                alert("보안 취약점 신고포상제 운영 안내서 숙지 여부를 확인해주세요.");
                return false;
            }

            //선택
            if (!dc.nullChk(data.otherAgencyYn)) {
                alert("KISA 신고 이전 취약점 공개 및 여부에 대해 예 또는 아니오를 선택해주세요.");
                return false;
            } else if (data.otherAgencyYn && !dc.nullChk(data.otherAgencyName)) {
                alert("공개 전 통보한 기관 또는 업체명을 입력해주세요.");
                return false;
            } else if (data.otherAgencyYn && !dc.nullChk(data.otherAgencyDate)) {
                alert("공개 전 통보한 일자를 선택해주세요.");
                return false;
            } else if (!dc.nullChk(data.govSupportYn)) {
                alert(
                    "정부 지원 사업을 통해 발굴된 취약점 여부에 대해 예 또는 아니오를 선택해주세요."
                );
                return false;
            } else if (!dc.nullChk(data.hasCveIdAgree)) {
                alert("CVE ID 발급에 대해 동의함 또는 동의안함을 선택해주세요.");
                return false;
            }
        }

        return true;
    },
    // 탭 이동 처리 함수(해외)
    triggerClickToTabForeign(index, data) {
        let page = index - 1;

        // 개인정보작성 페이지 유효성 체크
        if (page == 0) {
            if (!dc.nullChk(data.userName)) {
                alert("Please enter your name.");
                return "userName";
            } else if (!dc.nullChk(data.email) || !dc.emailValidChk(data.email)) {
                alert("Please enter your email correctly.\nInput Example) korea@kisa.co.kr");
                return "email";
            } else if (!dc.nullChk(data.phone)) {
                alert("Please enter your contact information.");
                return "phone";
            }
        }

        return true;
    },
    // 신고 접수 함수
    async submitReport(totalInfo, memberType) {
        const submitInfo = this.getMergedReportInfo(totalInfo);
        // 유효성 검증
        let validator = true;
        let completeMsg = "접수가 완료 되었습니다.페이지를 새로고침합니다.";
        let confirmMsg = "입력하신 정보로 신고하시겠습니까?";
        if (memberType === "foreigner") {
            confirmMsg = "Do you want to report with the information you entered?";
            completeMsg = "Your registration has been completed. Refresh the page.";
            validator = this.validateDataForeign(submitInfo);
        } else {
            validator = this.validateDataDomestic(submitInfo, memberType);
        }
        if (!validator) return false;

        if (memberType === "nonMember" || memberType === "foreigner") {
            await rsa.getPublicKey();
            submitInfo.reportInfo.phone = rsa.encryptData(submitInfo.reportInfo.phone);
            submitInfo.reportInfo.email = rsa.encryptData(submitInfo.reportInfo.email);
        }

        const formData = new FormData();

        if (totalInfo.uploadFile) {
            formData.append("files", totalInfo.uploadFile);
        }

        if (confirm(confirmMsg)) {
            let res = false;
            res = await editor.handleEditorImages(submitInfo.reportInfo, fields, "report");
            if (!res) {
                return res;
            }
            const payloadBlob = new Blob([JSON.stringify(submitInfo)], {
                type: "application/json; charset=utf-8",
            });

            formData.append("vo", payloadBlob, "payload.json");

            // 신고정보 등록 시작
            res = await this.addReportData(formData, completeMsg);
            return res;
        }
    },
    validateDataDomestic(item, memberType) {
        const data = item.reportInfo;

        // 회원/비회원 유효성 검증
        if (memberType === "nonMember") {
            // 비회원일때만
            if (!dc.nullChk(data.userName)) {
                alert("성명을 입력해주세요.");
                return false;
            } else if (!dc.nullChk(data.userEngName)) {
                alert("영문명을 입력해주세요.");
                return false;
            } else if (!dc.nullChk(data.email) || !dc.emailValidChk(data.email)) {
                alert("이메일을 정확하게 입력해주세요.\n입력예시) korea@kisa.co.kr");
                return false;
            } else if (!dc.nullChk(data.phone) || !dc.chkOnlyNumber(data.phone)) {
                alert("연락처를 입력해주세요.");
                return false;
            } else if (!data.privateYnTmp) {
                alert(
                    "취약점 신고를 진행하시려면 개인정보 수집 이용 취급 위탁에 동의하셔야 합니다."
                );
                return false;
            }
        }
        if (!this.triggerClickToTabDomestic(2, data)) {
            return false;
        }
        if (!data.rewardNm) {
            alert("포상 유형을 입력해주세요.");
            return false;
        } else if (!data.rewardSubNm) {
            alert("포상 유형을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulTitle)) {
            alert("취약점 제목을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulSummary)) {
            alert("취약점 요약을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.makr)) {
            alert("제조사를 선택해주세요.");
            return false;
        } else if (
            !dc.nullChk(data.forcedEntryMakrName) &&
            (data.makrName === "없음" || data.swNmText === "없음")
        ) {
            alert("제조사 혹은 소프트웨어가 없는경우 수기로 입력해주세요");
            return false;
            // 수기입력이 Null이면
        } else if (!dc.nullChk(data.forcedEntryMakrName) && !dc.nullChk(data.swNm)) {
            alert("소프트웨어를 선택해주세요.");
            return false;
        } else if (!dc.nullChk(data.ver)) {
            alert("버전을 입력해주세요.");
            return false;
        } else if (!data.makrSeCd || !data.makrSeCdMid || !data.makrSeCdSml) {
            alert("소프트웨어 유형을 선택해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulEnvironment.trim())) {
            alert("취약점 발생환경을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulDetection.trim())) {
            alert("취약점 발견방법을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulCause.trim())) {
            alert("취약점 발생원인을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulVerify.trim())) {
            alert("취약점 증명/검증 방법을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulScript.trim())) {
            alert("취약점 악용 시나리오를 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulAction.trim())) {
            alert("취약점 조치방안을 입력해주세요.");
            return false;
        }

        const message =
            "완성되지 않은 CVSS 계산 정보가 존재합니다\n이대로 접수진행을 계속 하시겠습니까?";
        if (!this.confirmCvssIncomplete(message, item)) {
            return false;
        }

        return true;
    },
    validateDataForeign(item) {
        const data = item.reportInfo;
        if (!dc.nullChk(data.userName)) {
            //성명
            alert("Please enter your name.");
            return false;
        } else if (!dc.nullChk(data.email) || !dc.emailValidChk(data.email)) {
            //이메일 검증
            alert("Please enter your email correctly.\nInput Example) korea@kisa.co.kr");
            return false;
        } else if (!dc.nullChk(data.phone) || !dc.chkOnlyNumber(data.phone)) {
            //연락처 입력
            alert("Please enter your contact information.");
            return false;
        } //동의 여부 리스트
        else if (!data.privateYnTmp) {
            alert(
                "In order to proceed with the vulnerability report, you must agree to the consignment of personal information collection and use."
            );
            return false;
        } else if (!dc.nullChk(data.privateThirdYn)) {
            alert(
                "Please select consent or disagreement to use/handle personal information collection."
            );
            return false;
        }
        //다른 기관 공개 여부
        else if (data.otherAgencyYn && !dc.nullChk(data.otherAgencyName)) {
            //통보대상
            alert("Please enter the name of the institution or company notified before disclosure");
            return false;
        } else if (data.otherAgencyYn && !dc.nullChk(data.otherAgencyDate)) {
            //통보일자
            alert("Please select the date you notified before disclosure.");
            return false;
        } else if (!dc.nullChk(data.vulTitle)) {
            //취약점 제목
            alert("Please enter the vulnerability title.");
            return false;
        } else if (!dc.nullChk(data.vulSummary)) {
            //취약점 요약
            alert("Please enter a vulnerability summary.");
            return false;
        } else if (!dc.nullChk(data.forcedEntryMakrName)) {
            // 제조사
            alert("Please enter manufacturer");
            return false;
        } else if (!dc.nullChk(data.vulEnvironment.trim())) {
            alert("Please enter the vulnerability environment.");
            return false;
        } else if (!dc.nullChk(data.vulDetection.trim())) {
            alert("Please enter the vulnerability detection method.");
            return false;
        } else if (!dc.nullChk(data.vulCause.trim())) {
            alert("Please enter the vulnerability cause.");
            return false;
        } else if (!dc.nullChk(data.vulVerify.trim())) {
            alert("Please enter the vulnerability verification method.");
            return false;
        } else if (!dc.nullChk(data.vulScript.trim())) {
            alert("Please enter the vulnerability exploitation scenario.");
            return false;
        } else if (!dc.nullChk(data.vulAction.trim())) {
            alert("Please enter the vulnerability remediation plan.");
            return false;
        }

        const message =
            "Some CVSS score information is incomplete.Do you want to proceed with the submission anyway?";
        if (!this.confirmCvssIncomplete(message, item)) {
            return false;
        }

        return true;
    },

    // cvss계산 확인
    confirmCvssIncomplete(message, item) {
        const evl = item?.reportCvssEval;
        if (item === null || evl === null) {
            return true;
        }

        if (evl?.evlItem?.cmptYn && !confirm(message)) {
            return false;
        }
        if (!dc.nullChk(evl.cvss) || evl.cvss === 0) {
            item.reportCvssEval = null;
        }

        return true;
    },
    // 취약점 정보 수정
    async setReport(totalInfo, modReportInfo) {
        const modTotalInfo = this.getMergedReportInfo(totalInfo);
        // 회원/비회원 유효성 검증
        if (!this.validateModData(modTotalInfo)) {
            return false;
        }

        const formData = new FormData();

        if (totalInfo.uploadFile) {
            formData.append("files", totalInfo.uploadFile);
        }

        if (confirm("수정 하시겠습니까?")) {
            let res = false;
            res = await editor.handleEditorImages(modTotalInfo.reportInfo, fields, "report");
            if (!res) {
                return res;
            }

            const voPayload = {
                canEdit: modReportInfo?.canEdit || false,
                reasonCode: modReportInfo?.reasonCode || "",
                description: modReportInfo?.description || "",
                reportInfo: modTotalInfo.reportInfo,
                feedback: modReportInfo?.feedback || [],
                status: modReportInfo?.status || "",
                reportCvssEval: modTotalInfo.reportCvssEval || null,
            };

            const payloadBlob = new Blob([JSON.stringify(voPayload)], {
                type: "application/json; charset=utf-8",
            });

            formData.append("vo", payloadBlob, "payload.json");

            // 신고정보 수정 시작
            res = await this.setReportData(formData);
            return res;
        }
    },
    validateModData(item) {
        const data = item.reportInfo;
        if (!data.rewardNm) {
            alert("포상 유형을 입력해주세요.");
            return false;
        } else if (!data.rewardSubNm) {
            alert("포상 유형을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulTitle)) {
            alert("취약점 제목을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.vulSummary)) {
            alert("취약점 요약을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.makr)) {
            alert("제조사를 선택해주세요.");
            return false;
        } else if (!dc.nullChk(data.swNm)) {
            alert("소프트웨어명을 입력해주세요.");
            return false;
        } else if (!dc.nullChk(data.ver)) {
            alert("버전을 입력해주세요.");
            return false;
        } else if (!data.makrSeCd || !data.makrSeCdMid || !data.makrSeCdSml) {
            alert("소프트웨어 유형을 선택해주세요.");
            return false;
        }
        const message =
            "완성되지 않은 CVSS 계산 정보가 존재합니다\n이대로 접수진행을 계속 하시겠습니까?";
        if (!this.confirmCvssIncomplete(message, item)) {
            return false;
        }

        return true;
    },
    // 취약점 신고 api 호출
    async addReportData(formData, completeMsg) {
        return axios
            .post("/report/pr/submission/add", formData)
            .then((res) => {
                if (res.data.resType === "RES_OK") {
                    alert(completeMsg);
                    return true;
                } else {
                    alert(res.data.resMsg);
                    return false;
                }
            })
            .catch((error) => {
                console.error(error);
                return false;
            });
    },
    // 취약점 수정 api 호출
    async setReportData(formData) {
        return await axios
            .post("/report/pr/records/set", formData)
            .then((res) => {
                if (res.data.resType === "RES_OK") {
                    deleteAllIndexedDBs();
                    alert("신고 정보 수정이 완료되었습니다.");
                    return true;
                } else {
                    alert(res.data.resMsg);
                    return false;
                }
            })
            .catch((error) => {
                console.error(error);
                return false;
            });
    },
    // 신고포상제 대분류 코드 조회
    async getRewardNm() {
        try {
            const response = await axios.post("/report/pr/code/reward/get");
            if (response.data.resType === "RES_OK") {
                return response.data.resList;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    // 신고포상제 대분류 선택 시 소분류 세팅
    async selectRewardNm(mainId) {
        try {
            const response = await axios.post("/report/pr/code/reward/sub/get", { mainId });
            if (response.data.resType === "RES_OK") {
                return response.data.resList;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    // 소프트웨어 유형 대분류 코드 조회
    async getMakrSeCd() {
        try {
            const response = await axios.post("/report/pr/code/se/get");
            if (response.data.resType === "RES_OK") {
                return response.data.resList;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    // 소프트웨어 유형 대분류 선택 시 중분류 코드 조회
    async selectMakrSeCd(parntsCode) {
        try {
            const response = await axios.post("/report/pr/code/se/sub/get", { parntsCode });
            if (response.data.resType === "RES_OK") {
                return response.data.resList;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    // 소프트웨어 유형 중분류 선택 시 소분류 코드 조회
    async selectMakrSeCdMid(parntsCode) {
        try {
            const response = await axios.post("/report/pr/code/se/sub/get", { parntsCode });
            if (response.data.resType === "RES_OK") {
                return response.data.resList;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    // 공격 유형 코드 조회
    async getVulAttackType() {
        try {
            const response = await axios.post("/report/pr/code/attack-type/get");
            if (response.data.resType === "RES_OK") {
                return response.data.resList;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    // 영향 코드 조회
    async getVulEffect() {
        try {
            const response = await axios.post("/report/pr/code/effect/get");
            if (response.data.resType === "RES_OK") {
                return response.data.resList;
            }
            return null;
        } catch (error) {
            console.error(error);
            return null;
        }
    },
    async tempSave(data) {
        return axios
            .post("/report/pr/submission/temp/add", data)
            .then((res) => {
                if (res.data.resType === "RES_OK") {
                    return true;
                }
            })
            .catch((error) => {
                console.error(error);
            });
    },
    async loadTempData() {
        // 임시저장 데이터 불러오기
        return axios
            .get("/report/pr/submission/temp/get")
            .then((res) => {
                if (res.data.resType === "RES_OK") {
                    return res.data.resList;
                }
            })
            .catch((error) => {
                console.error(error);
            });
    },
    autoSave(val, data) {
        const intervalMs = this.getAutoSaveInterval(val);
        const now = new Date();
        if (!tt) {
            tt = now;
            this.tempSave(this.getMergedReportInfo(data));
            return;
        }
        const diff = now.getTime() - tt.getTime();
        if (diff >= intervalMs) {
            tt = now;
            this.tempSave(this.getMergedReportInfo(data));
        }
    },
    getAutoSaveInterval(val) {
        return val ? Number(val) * 60000 : 30000;
    },
    getAllowAttachFileExt() {
        return ["pdf", "xlsx", "xls", "zip"];
    },
    createModReportInfo() {
        return {
            hasDistributed: false,
            canEdit: false,
            reasonCode: "",
            description: "",
            uploadFile: null,
        };
    },
    getMergedReportInfo(totalInfo) {
        const merged = {
            ...totalInfo.reportInfo,
            ...totalInfo.agree,
            ...totalInfo.personal,
        };
        return {
            reportInfo: merged,
            reportCvssEval: totalInfo.cvssEval,
        };
    },
    getTotalInfo() {
        return {
            reportInfo: this.createDefaultReportInfo(),
            agree: this.createDefaultAgreeInfo(),
            personal: this.createDefaultPersonalInfo(),
            cvssEval: { cvss: null, severity: null, evlItem: {} },
            uploadFile: null,
        };
    },

    createDefaultPersonalInfo() {
        return {
            userName: null,
            userEngName: null,
            email: null,
            phone: null,
            privateYnTmp: null,
            privateYnReward: "",
        };
    },
    createDefaultAgreeInfo() {
        return {
            privateThirdYn: null,
            otherAgencyYn: null,
            otherAgencyName: null,
            otherAgencyDate: null,
            excludingRewardsYn: null,
            secureYn: null,
            govSupportYn: null,
            hasCveIdAgree: null,
            hasBugBountyGuideRead: null,
            hasNetworkLawConfirmed: null,
        };
    },
    createDefaultReportInfo() {
        return {
            regDate: null,
            phoneType: "",
            vulTitle: "",
            vulSummary: "",
            vulEnvironment: "",
            vulEnvironmentHtml: "",
            vulDetection: "",
            vulDetectionHtml: "",
            vulCause: "",
            vulCauseHtml: "",
            vulVerify: "",
            vulVerifyHtml: "",
            vulScript: "",
            vulScriptHtml: "",
            vulAction: "",
            vulActionHtml: "",
            vulFile: "",
            vulMethod: "",
            vulUrl: "",
            vulParam: "",
            vulEff: "",
            effectDesc: "",
            vulAttack: "",
            attackDesc: "",
            makrSeCd: "",
            makrSeCdMid: "",
            makrSeCdSml: "",
            rewardNm: "",
            rewardNmStr: "",
            rewardSubNm: "",
            rewardSubNmStr: "",
            bohoYN: "",
            nickname: "",
            website: "",
            privateYn: "",
            makrName: "",
            makr: "",
            swNm: "",
            swNmText: "",
            forcedEntryMakrName: "",
            vulEtc: "",
            vulMembership: "Y",
            kve: "",
            status: "",
            attachNm: "",
            attachPath: "",
            ver: "",
            userGroup: "",
            userAddress: "",
            userDetailAddress: "",
            isChild: "",
            obtinCours: "",
            reportTextData: "",
        };
    },
};
